import { render, staticRenderFns } from "./SearchRules.vue?vue&type=template&id=2495507b&scoped=true"
import script from "./SearchRules.vue?vue&type=script&lang=js"
export * from "./SearchRules.vue?vue&type=script&lang=js"
import style0 from "./SearchRules.vue?vue&type=style&index=0&id=2495507b&scoped=true&lang=scss"
import style1 from "./SearchRules.vue?vue&type=style&index=1&id=2495507b&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2495507b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src117016002/src/console/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2495507b')) {
      api.createRecord('2495507b', component.options)
    } else {
      api.reload('2495507b', component.options)
    }
    module.hot.accept("./SearchRules.vue?vue&type=template&id=2495507b&scoped=true", function () {
      api.rerender('2495507b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modules/Settings/SearchRules.vue"
export default component.exports